"use client";

import type React from "react";

import { GripVertical } from "lucide-react";
import * as ResizablePrimitive from "react-resizable-panels";

import { cn } from "@/lib/utils";

const ResizablePanelGroup = ({
  className,
  ...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelGroup>) => (
  <ResizablePrimitive.PanelGroup
    className={cn(
      "flex h-full w-full data-[panel-group-direction=vertical]:flex-col",
      className,
    )}
    {...props}
  />
);

const ResizablePanel = ResizablePrimitive.Panel;

const ResizableHandle = ({
  withHandle,
  className,
  onClick,
  isMinimized = false,
  ...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelResizeHandle> & {
  withHandle?: boolean;
  onClick?: () => void;
  isMinimized?: boolean;
}) => (
  <ResizablePrimitive.PanelResizeHandle
    className={cn(
      "group relative flex w-[6px] items-center justify-center transition-[background-color,border-color,transform] duration-200 ease-in-out",
      className,
    )}
    {...props}
  >
    {withHandle && (
      <div
        className={cn(
          "border-dark-border relative z-10 flex h-6 w-2 items-center justify-center rounded-sm border bg-black transition-[background-color,border-color] duration-300 ease-in-out group-hover:border-orange-500 group-hover:bg-orange-500",
          !isMinimized && "-mr-3",
        )}
        onClick={onClick}
      >
        <GripVertical className="h-2.5 w-2.5" />
      </div>
    )}
  </ResizablePrimitive.PanelResizeHandle>
);

export { ResizablePanelGroup, ResizablePanel, ResizableHandle };
